// extracted by mini-css-extract-plugin
export default {"product-modal-list":"product-modal_product-modal-list__XUUQU"};